import React from "react"
import Helmet from "react-helmet"
import "font-awesome/scss/font-awesome.scss"
import Navigation from "../components/Navigation/Navigation"
import config from "../../data/SiteConfig"

import "./index.scss"


export default class MainLayout extends React.Component {
  getLocalTitle() {
    const pathPrefix = config.pathPrefix ? config.pathPrefix : "/"
    const currentPath = this.props.location.pathname
      .replace(pathPrefix, "")
      .replace("/", "")
    let title = ""
    switch (currentPath) {
      case "":
      title = config.siteTitle
      break
      case "acerca":
      title = "Acerca"
      break
      case "creditos":
      title = "Créditos"
      break
      case "programacion":
      title = "Programación"
      break
      case "galeria":
      title = "Galería"
      break
      default:
      title = config.siteTitle
      break
    }
    return title
  }
  render() {
    const { children } = this.props
    return (
      <Navigation config={config} LocalTitle={this.getLocalTitle()}>
        {children()}
      </Navigation>
    )
  }
}


// WEBPACK FOOTER //
// ./src/layouts/index.js